<template>
  <div>
    <div class="inserts">
      <div id="insert-svg-container">
      </div>

      <div class="inserts-list">
        <div
          class="inserts-list__header"
          :class="{ 'inserts-list__header--active': !!activeInsertCategoryId  }"
        >
          ADD INSERT
        </div>

        <div v-if="isInsertCategoriesPending" class="loader">
          <b-spinner label="Loading..." variant="primary"/>
        </div>

        <!-- Show Categories -->

        <div v-if="!activeInsertCategoryId">
          <div
            v-for="categoryId in insertCategories.ids"
            :key="categoryId"
            class="category"
            v-on:click="selectInsertCategory(categoryId)"
          >
            <div class="category__name">{{insertCategories.data[categoryId].name}}</div>
          </div>
        </div>

        <div v-if="activeInsertCategoryId">
          <div class="category category--active" v-on:click="unSelectInsertCategory()">
            <div class="category__name">{{insertCategories.data[activeInsertCategoryId].name}}</div>
          </div>

          <div v-if="isInsertsPending" class="loader">
            <b-spinner label="Loading..." variant="primary"/>
          </div>

          <div class="inserts-icons">
            <div
              class="empty-list-label"
              v-if="insertCategories.data[activeInsertCategoryId].insertIds &&
              insertCategories.data[activeInsertCategoryId].insertIds.length === 0"
            >
              <div>No elements found</div>
            </div>

            <div
              v-for="insertId in insertCategories.data[activeInsertCategoryId].insertIds"
              :key="insertId"
              class="patch-item"
            >
              <div v-show="inserts[insertId].isPending" class="loader">
                <b-spinner label="Loading..." variant="primary"/>
              </div>

              <div style="width: 100%; height: 100%"
                   v-if="!inserts[insertId].isPending">
                <drag
                  :transfer-data="{ insertId, insert: inserts[insertId]}"
                  style="width: 100%; height: 100%;"
                  @dragstart="handleInsertDragStart"
                  v-on:dblclick.native="onAddInsert(insertId,
                inserts[insertId].name, inserts[insertId].categoryId,
                inserts[insertId].width, inserts[insertId].height)"
                >

                    <div class="insert-wrap"
                         v-html="inserts[insertId].svgText" >
                    </div>
                    <template slot="image">
                      <div
                        v-if="currentBrowser === 'Safari'"
                        style=
                          "width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center">

                        <img style="width: 100%;
                            height: 100%;"
                             :src="inserts[insertId].fileUrl">
                      </div>
                      <div v-html="inserts[insertId].svgText" v-else
                           style=
                             "width: 100%;
                            height: 100%">
                      </div>
                    </template>

                </drag>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!!activeInsertElement" class="list-colors">
          <div class="list-colors__header">INSERT COLORS</div>

          <ul class="colorpicker">
            <PatchColorItem
              v-for="(colorData, i) in activeInsertColors.filter((item) => !!item)"
              :id="`insert-${colorData.layerId}`"
              :key="`insert-${colorData.layerId}`"
              :colorId="colorData.id"
              :color="colorData.color"
              :layer-id="colorData.layerId"
              :material="colorData.material"
              :index="i"
              @onChangeColor="onChangeInsertColor"
            />
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as SVG from 'svg.js/dist/svg';
import PatchColorItem from '@/components/canvas/PatchColorItem.vue';
import SvgMixin from '@/components/canvas/SvgMixin';
import { ONE_INCH_IN_PX } from '@/common/constants';
import Bowser from 'bowser';

export default {
  name: 'InsertsSidebar',
  components: {
    PatchColorItem
  },

  mixins: [SvgMixin],

  data: () => ({
    canvas: null,
  }),

  props: {
    activeInsertElement: Object,
  },

  computed: {
    currentBrowser () {
      return Bowser.getParser(window.navigator.userAgent)
        .parsedResult.browser.name;
    },

    activeInsertColors () {
      return this.$store.getters['design/getActiveInsertColors'];
    },

    isInsertCategoriesPending () {
      return this.$store.getters['elements/isInsertCategoriesPending'];
    },

    isInsertsPending () {
      return this.$store.getters['elements/isInsertsPending'];
    },

    activeInsertCategoryId () {
      return this.$store.getters['elements/getActiveInsertCategoryId'];
    },

    insertCategories () {
      return this.$store.getters['elements/getInsertCategories'];
    },

    inserts () {
      return this.$store.getters['elements/getInserts'];
    },
  },

  mounted () {
    // console.log(this.currentBrowser);
    this.canvas = SVG('insert-svg-container').size(600, 500);
    this.canvasId = 'insert-canvas';
    this.canvas.id(this.canvasId);
    this.canvas.group().id(`${this.canvasId}--wrapper`);

    this.loadInsertCategories();

    if (this.activeInsertCategoryId) {
      const activeInsertCategory = this.insertCategories.data[this.activeInsertCategoryId];
      if (activeInsertCategory.insertIds.length > 0) {
        this.getInsertColors(activeInsertCategory.insertIds[0]);
      }
    }
  },

  methods: {
    loadInsertCategories () {
      if (this.insertCategories.ids.length === 0) {
        this.$store.dispatch('elements/loadInsertCategories');
      }
    },

    selectInsertCategory (categoryId) {
      const category = this.insertCategories.data[categoryId];
      this.$store.dispatch('elements/setActiveInsertCategory', categoryId);

      if (category.insertIds && category.insertIds.length > 0) return false;

      this.$store.dispatch('elements/loadInsertsByCategory', categoryId).then(() => {
        const promises = category.insertIds.map((insertId) => {
          const promise = this.$store.dispatch('elements/loadInsert', insertId);
          this.$forceUpdate();
          return promise;
        });

        Promise.all(promises).then(() => {
          this.$forceUpdate();
          this.getInsertColors(category.insertIds[0]);
        });
      });

      return true;
    },

    unSelectInsertCategory () {
      this.$store.dispatch('elements/setActiveInsertCategory', null);
    },

    handleInsertDragStart (transferData, event) {
      /* eslint-disable */
      transferData.offsetX = event.offsetX;
      transferData.offsetY = event.offsetY;
      transferData.width = transferData.insert.width * ONE_INCH_IN_PX;
      transferData.height = transferData.insert.height * ONE_INCH_IN_PX;
      /* eslint-enable */
    },

    onAddInsert (insertId, name, categoryId, insertWidth, insertHeight) {
      const width = insertWidth * ONE_INCH_IN_PX;
      const height = insertHeight * ONE_INCH_IN_PX;

      this.$emit('addInsertOnPatch', {
        insertId, name, categoryId, width, height
      });
    },

    onChangeInsertColor (newColor, layerId) {
      this.$store.commit('design/setActiveInsertColors', this.changeColorsData(this.activeInsertColors, layerId, newColor));
      this.$emit('onChangeInsertColor', {
        newColor,
        layerId,
        colors: this.activeInsertColors
      });
    },

    getInsertColors (insertId) {
      const insert = this.inserts[insertId];

      const insertElement = this.createInsertSvg(insert.svgText, false, 'temp-insert', 0, 0);

      const colors = this.getColorsByProperty('temp-insert', 'FILL', 'fill');
      const stroke = this.getColorsByProperty('temp-insert', 'STROKE', 'STROKE');

      if (stroke.length > 0) {
        colors.splice(1, 0, stroke[0]);
      }
      insertElement.remove();
    },
  }
};
</script>

<style scoped>
  #insert-svg-container {
    display: none;
  }

  .inserts {
    background: #fff;
    border: 1px solid #fff;
    position: absolute;
    right: 15px;
    top: 0;
    width: 150px;

    .loader {
      text-align: center;
      margin-top: 10px;
    }
  }

  .inserts-list {
    &__header {
      background: #1c539c;
      color: #ffffff;
      font-weight: bold;
      padding: 5px 10px;

      &--active {
        background: #cbcaca;
        color: #000;
      }
    }

    .category {
      cursor: pointer;
      padding: 5px 10px;

      &:hover {
        background: #e6e7e8;
      }

      &.category--active {
        background: #1c539c;
        color: #ffffff;
      }
    }

    .inserts-icons {
      text-align: center;
      max-height: 380px;
      overflow: auto;
    }

    .patch-item {
      width: 100px;
      height: 100px;
      margin: 15px auto;
    }

    .patch-item__preview {
    }

    .insert-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .insert-wrap >>> #Layer_1 {
      width: 100%;
      height: 100%;
    }

    .empty-list-label {
      margin: 10px;
      text-align: left;
    }
  }
</style>
